import { Table } from 'semantic-ui-react';
import { RoomForSpeakingSessionDto } from 'api/planning';
import { AvailableRoom } from './AvailableRoom';
import { useCheckbox } from 'hooks';
import { useMemo } from 'react';

type Props = {
  availableRooms: RoomForSpeakingSessionDto[];
  onSelectedRoomsChanged: (roomIds: number[]) => void;
  searchTerm: string | undefined;
};

export const AvailableRoomsTable = ({
  availableRooms,
  onSelectedRoomsChanged,
  searchTerm,
}: Props) => {
  const { isChecked, onCheckboxChange } = useCheckbox(onSelectedRoomsChanged);

  const rows = useMemo(() => {
    return availableRooms
      .filter(
        (x) =>
          !searchTerm ||
          searchTerm.length < 2 ||
          x.building.toLowerCase().includes(searchTerm.toLowerCase()) ||
          x.floor.toLowerCase().includes(searchTerm.toLowerCase()) ||
          x.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .map((x) => (
        <AvailableRoom
          room={x}
          onChange={onCheckboxChange(x.id)}
          checked={isChecked(x.id)}
          key={`available-room-${x.id}`}
        />
      ));
  }, [availableRooms, isChecked, onCheckboxChange, searchTerm]);

  return (
    <Table celled striped attached size="small" data-testid="available-rooms-table-speaking">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} />
          <Table.HeaderCell width={1} />
          <Table.HeaderCell>Building</Table.HeaderCell>
          <Table.HeaderCell>Floor</Table.HeaderCell>
          <Table.HeaderCell>Room</Table.HeaderCell>
          <Table.HeaderCell>Properties</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};
